import { IdeaEditStepProps } from "./EditIdeaPage.tsx";
import UsersChooser from "../../../components/users/UsersChooser.tsx";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { ChangeEvent, useCallback } from "react";

export default function AudienceChooserStep(props: IdeaEditStepProps & { connections: string[] }) {

    const [idea, setIdea] = props.control

    const handleNetworkAccessChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        let checked = event.target.checked
        setIdea((idea) => ({ ...idea, accessors: { ...idea.accessors, network: checked } }))
    }, [idea])

    const onUserSelectionChange = useCallback((selectedUsers: string[]) => {
        setIdea((idea) => ({ ...idea, accessors: { ...idea.accessors, userIds: selectedUsers } }))
    }, [idea])

    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <Switch
                        checked={idea.accessors.network}
                        onChange={handleNetworkAccessChange}
                    />
                }
                label="Alle meine Kontakte"
            />

            {!idea.accessors.network && (
                <UsersChooser
                    userIds={props.connections}
                    selectedUserIds={idea.accessors.userIds || []}
                    onSelectionChange={onUserSelectionChange}
                />
            )}

            {/*{connectionsChooserEl}*/}
        </FormGroup>
    )
}